// type

import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";

import icons from "helper/iconsHelper";

import {
  can_add_clients,
  can_edit_clients,
  can_view_clients,
  per_view_users,
} from "../helper/permissionsCheck";
// icons

// let permissionUser = localStorage.getItem("LoginData");
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    console.log(error, "er");
  }
}

const permissions = decryptedData
  ? JSON.parse(decryptedData)?.permissions
  : null;

const allowedPermissions =
  permissions && permissions.length !== 0
    ? permissions.map((permission) => permission?.permission)
    : [];

const permissionsAccessFunction = (brand) => {
  return (
    allowedPermissions &&
    allowedPermissions.length !== 0 &&
    allowedPermissions.some((permission) => permission.includes(brand))
  );
};
// ==============================|| MENU ITEMS - roles ||============================== //

// const flat = permissionsAccessFunction('company') ? {
const alluserss = per_view_users
  ? {
      id: "all-users",
      title: "User Management",
      icon: icons.users,
      type: "group",
      children: [
        per_view_users
          ? {
              id: "all-users",
              title: "User Management",
              type: "item",
              url: "/users/all-users",
              icon: icons.users,
              breadcrumbs: true,
            }
          : null,
      ].filter(Boolean),
    }
  : null;
export default alluserss;
